module.exports = __webpack_public_path__ + "img/SWHY.3f646686.png";